import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VCardTitle,[_c('span',[_vm._v(" Contratos ")])]),_c(VDataTable,{attrs:{"loading":_vm.loading,"loading-text":"Carregando dados... Por favor, aguarde","headers":_vm.headers,"items":_vm.itemsTable,"items-per-page":10},scopedSlots:_vm._u([{key:"item.created_at",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.dateFormat(item.created_at))+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }